import React from "react";
import "./Verification.css";
import VerificationInput from "react-verification-input";

export default function Verification(props) {

  return (
    <div className="customVerificationInput centeredFlex">
      <VerificationInput
        classNames={{
          container: "verificationInputContainer centeredFlex",
          character: `verificationInputCharacter centeredFlex ${
            props.isComplete && "completeCode"
          }`,
          characterInactive: "character--inactive",
          characterSelected: "character--selected",
        }}
        length={5}
        placeholder=""
        validChars="0-9"
        onComplete={(code) => props.onComplete(code)}
        inputComponent={({ value, setValue }) => (
          <input
            type="tel"
            value={value}
            onChange={(e) => setValue(e.target.value.replace(/\D/g, ""))}
          />
        )}
      />
    </div>
  );
}
